import { render, staticRenderFns } from "./students-manual-ghiab.vue?vue&type=template&id=c3289b26&"
import script from "./students-manual-ghiab.vue?vue&type=script&lang=js&"
export * from "./students-manual-ghiab.vue?vue&type=script&lang=js&"
import style0 from "./students-manual-ghiab.vue?vue&type=style&index=0&id=c3289b26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports